import axios from 'axios';
import * as types from '@/store/mutation-types';
import {createUrlQueryString} from '@/utils/urls';
import {performApiRequest} from '@/store/helpers/vuex-helpers';
import {push} from 'notivue';
import {handleApiError} from '@/utils/errorHandler.ts';

export interface Barcode {
    barcode_type: string;
    owner_id: string;
    owner_type: string;
    created_at?: string;
    image_url?: string;
    number?: string;
    barcode_number?: string | null;
    updated_at?: string;
    uuid?: string;
}


export interface BarcodeState {
    loading: Record<string, boolean>;
    barcode: Barcode | null;
}

// state
const state: BarcodeState = {
    loading: {
        fetchCart: false,
        delete: false,
        create: false,
    },
    barcode: null,
};

const getters = {
    loading: (state: BarcodeState) => state.loading,
    barcode: (state: BarcodeState) => state.barcode,
};

const mutations = {
    [types.SET_BARCODE_LOADING](state: BarcodeState, loading: { subject: string, loading: boolean }) {
        state.loading[loading.subject] = loading.loading;
    },
    [types.SET_BARCODE](state: BarcodeState, barcode: Barcode) {
        state.barcode = barcode;
    },
};

const actions = {

    async findBarcode({commit}, payload: Record<string, string>) {
        const queryString = createUrlQueryString(payload);
        const responseData = await performApiRequest(commit, 'SET_BARCODE_LOADING', 'create', () => axios.get(`/v1/barcodes${queryString}`));
        commit(types.SET_BARCODE, responseData.barcode);
    },


    /**
     * Update a barcode
     */
    async updateBarcode({commit}, barcode: Barcode) {
        try {
            const responseData = await performApiRequest(commit, 'SET_BARCODE_LOADING', 'create', () => axios.put(`/v1/barcodes/${barcode.uuid}`, barcode));
            commit(types.SET_BARCODE, responseData.barcode);
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    },


    /**
     * Create a new barcode
     */
    async createBarcode({commit}, data: Barcode) {
        try {
            const responseData = await performApiRequest(commit, 'SET_BARCODE_LOADING', 'create', () => axios.post('/v1/barcodes', data));
            commit(types.SET_BARCODE, responseData.barcode);
            push.success({
                message: 'Barcode created successfully',
            });
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    },

    /**
     * Delete a barcode
     */
    async deleteBarcode({commit}, barcode: Barcode) {
        try {
            await performApiRequest(commit, 'SET_BARCODE_LOADING', 'delete', () => axios.delete(`/v1/barcodes/${barcode.uuid}`));
            commit(types.SET_BARCODE, null);
            push.success({
                message: 'Barcode deleted successfully',
            });
        } catch (error) {
            handleApiError(error);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
